import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export default class ViewState {
  constructor(opts) {
    _defineProperty(this, "_viewportProps", void 0);

    _defineProperty(this, "_state", void 0);

    this._viewportProps = this._applyConstraints(opts);
  }

  getViewportProps() {
    return this._viewportProps;
  }

  getState() {
    return this._state;
  }

  shortestPathFrom(viewState) {
    return this._viewportProps;
  }

  _applyConstraints(props) {
    return props;
  }

}
//# sourceMappingURL=view-state.js.map